/** Mesmo ID fixo do backend (masterSupportAuth). */
export const MASTER_SUPPORT_USER_ID = '00000000-0000-4000-8000-000000000001';

export function isMasterSupportUser(userId?: string | null): boolean {
  return userId === MASTER_SUPPORT_USER_ID;
}
